// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2091":"749a3809","3233":"749a3809","3575":"ce044c50","4935":"08d55499","6641":"749a3809","6782":"749a3809"}[chunkId] + ".chunk.css";
};